import React, { Component } from "react";
import { Alert, Row, Card, CardTitle, Form, Label, Button,FormGroup , Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";
import NewTransportationCompany from "../../components/admin/NewTransportationCompany";
// import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import axios from "../../containers/api";
import SweetAlert from "react-bootstrap-sweetalert";
import { showCatchError, toEnglishNumbers } from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
class RegisterTransportationCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SendActiveCode: true, 
      CheckActiveCode: false, 
      IsActive: false, 
      Mobile: "",
      ActiveCode: "",
      Register: false,
      ProvinceList: [],
      TransportationCompanyName: "",
      NationalId: "",
      Province: null,
      CityList: [],
      City: null,
      newMemberUsername: "",
      newMemberPassword: "",
        showNewMember: false,
        errors: [],
        Mobile: (this.props.location.state !== undefined && this.props.location.state !== null) ? (this.props.location.state[0].mobile !== null && this.props.location.state[0].mobile !== undefined) ? this.props.location.state[0].mobile : null : null,
    };
  }
  onUserRegister() {
    if (this.state.email !== "" && this.state.password !== "") {
      this.props.history.push("/");
    }
    }
    componentWillMount() {
        this.loadProvinces();
    }
  loadProvinces = () => {
   // this.props.showSpinner();
    axios.get('api/v1/Province/GetAll')
        .then((res) => {
         //   this.props.hideSpinner();
            this.setState({ProvinceList: res.data.data});
        })
        .catch((error) => {
           // this.props.hideSpinner();
           // this.props.showAlert(showCatchError(error), "error");
            console.log(error.response);
        });
};
loadCities = (id) => {
  //this.props.showSpinner();
  axios.get('api/v1/City/GetCityByProvinceId?provinceId=' + id)
      .then((res) => {
        //  this.props.hideSpinner();
          this.setState({CityList: res.data.data});
      })
      .catch((error) => {
         // this.props.hideSpinner();
         // this.props.showAlert(showCatchError(error), "error");
          console.log(error.response);
      });
};
validateInputData = () => {
  //this.props.closeSweetAlert();
  let error = [];
  if (this.state.TransportationCompanyName.length ===0) {
      error.push("وارد كردن نام  الزامی میباشد");
  }
  if (this.state.NationalId.length < 10 ) {
      error.push("کد ملی نباید کمتر از ۱۰ حرف باشد.");
  }
  if (this.state.Mobile.length === 0) {
      error.push("وارد كردن تلفن يا موبايل الزامی میباشد.");
  }
 
  if (this.state.City === null || this.state.City === undefined) {
      error.push("انتخاب شهر الزامی میباشد.");
  }

  this.setState({errors: error});
  if (error.length === 0) {
      this.AddTransportationCompany();
  } else {
      
      this.props.showAlert(error, "error");
  }
};

AddTransportationCompany= () => {
  const addModel = {
      TransportationCompanyName: toEnglishNumbers(this.state.TransportationCompanyName),
      Email: "",
      NationalId: toEnglishNumbers(this.state.NationalId),
      Address: "",
      PostalCode: "",
      Tell: "",
      Mobile: toEnglishNumbers(this.state.Mobile),
      CityId: this.state.City !== null ? this.state.City.cityId : null
  };

  //this.props.showSpinner();
  axios.post('api/v1/TransportationCompany/AddTransportationCompany', addModel)
      .then((res) => {
          //this.props.hideSpinner();
          if (res.status === 200 && res.data.data!==-1) {
              this.setState({
                  newMemberUsername: res.data.data.userName,
                  newMemberPassword: res.data.data.password,
                  Register: false,
                  showNewMember: true
              });
          }
          else {
              this.props.showAlert(res.data.message, "error");  
          }
      })
      .catch((error) => {
          //this.props.hideSpinner();
          //this.props.showAlert(showCatchError(error), "error");
          console.log(error.response);
      });
};

selectHandleChange = (event, value, name) => {
  this.setState({ [name]: value },
      () => {
          if (name === "Province") {
              if (value !== undefined && value !== null) {
                  this.setState({
                      City: null
                  }, () => this.loadCities(value.provinceId));
              }
              else {
                  this.setState({
                      City: null, CityList: []
                  })
              }
          }

      });
};
  render() {
    return (
      <Row className="justify-content-center align-items-center d-flex mt-5">
      <Colxx xxs="12" md="8">
        <Card className="auth-card">
          <div className="form-side justify-content-center align-items-center d-flex flex-column">
            <div className="logo-single mb-2"/>
           

                        
                        
                        <div className="flex-column w-100 justify-content-center">
                            
                        <FormGroup className="w-md-50 w-100 mx-1">
                        <Label>موبایل</Label>
                                <Input value={this.state.Mobile} maxLength={11} disabled={true}
                               onChange={(e) => this.setState({ Mobile: e.target.value })}/>
                    </FormGroup>
                    <FormGroup className="w-md-50 w-100 mx-1">
                        <Label>نام شرکت حمل و نقل</Label>
                        <Input value={this.state.TransportationCompanyName} maxLength={300}
                               onChange={(e) => this.setState({ TransportationCompanyName: e.target.value })}/>
                    </FormGroup>
                    <FormGroup className="w-md-50 w-100 mx-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.NationalId} maxLength={11}
                               onChange={(e) => this.setState({ NationalId: e.target.value })}/>
                    </FormGroup>
                    <FormGroup className="w-md-50 w-100 mx-1">
                        <Label>استان</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="Province"
                            options={this.state.ProvinceList}
                            getOptionLabel={(option) => option.provinceName}
                            value={this.state.Province}
                            onChange={(e, v) => this.selectHandleChange(e, v, "Province")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-50 w-100 mx-1">
                        <Label>شهر</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="City"
                            options={this.state.CityList}
                            getOptionLabel={(option) => option.cityName}
                            value={this.state.City}
                            onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                            </FormGroup>
                            
                    <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.validateInputData()}>
                                 ثبت نام
                            </Button>
                            
                            <Link to={"/"} type="button">
                                <Button outline color="warning" className="mx-3 my-md-0 my-1">
                                    ورود به پنل
                                </Button>
                            </Link>
                            
                        </div>
                     
                     {this.state.showNewMember === true &&
                    <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                        <FormGroup className="w-md-50 w-100 mx-1">
                            <Label> نام کاربری</Label>
                            <Input value={this.state.newMemberUsername} disabled onChange={(e) => this.setState({ newMemberUsername: e.target.value })} />
                        </FormGroup> 
                        <FormGroup className="w-md-50 w-100 mx-1">
                            <Label> کلمه عبور</Label>
                            <Input value={this.state.newMemberPassword} disabled onChange={(e) => this.setState({ newMemberPassword: e.target.value })} />
                        </FormGroup> 
                    </div>
                    }
            </div>
            </Card>
          </Colxx>

  
            
      
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    registerUser
  }
)(RegisterTransportationCompany);
